module.exports = __webpack_public_path__ + "img/1.25e6bb74.png";